import React, { useState } from 'react'

import { DroppableItem } from '../../../DroppableItem'
import { Item } from '../../../Item'

const validateName = (value) => {
  const trimmed = value.trim()
  if (!trimmed) {
    return 'Name is required.'
  }
  if (trimmed.length > 30) {
    return 'Name must be 30 characters or fewer.'
  }
  return ''
}

export default function InventoryItem({
  index,
  entity,
  el,
  isSubItem = false,
  styles,
  data,
  parentId,
  canEdit,
  canAdd,
  canRemove,
  handleRemove,
  handleAdd,
  getObjectTotalSeatCount,
  isDroppableInSelected,
  setHolds,
  setKills,
  holdLetter,
}) {
  const { name, color } = el
  const setInventory = entity === 'hold' ? setHolds : setKills
  const canEditName = canEdit && Boolean(setInventory)

  const [nameHover, setNameHover] = useState(false)
  const [isEditingName, setIsEditingName] = useState(false)
  const [tempName, setTempName] = useState(name || '')
  const [nameError, setNameError] = useState('')

  const commitNameChange = () => {
    if (!canEditName) return
    const error = validateName(tempName)
    setNameError(error)
    if (error) return

    const trimmedName = tempName.trim()
    setInventory((prevState) => {
      if (parentId) {
        if (!prevState?.[parentId]?.categories?.[el.id]) return prevState
        return {
          ...prevState,
          [parentId]: {
            ...prevState[parentId],
            categories: {
              ...prevState[parentId].categories,
              [el.id]: {
                ...prevState[parentId].categories[el.id],
                name: trimmedName,
              },
            },
          },
        }
      }

      if (!prevState?.[el.id]) return prevState
      return {
        ...prevState,
        [el.id]: {
          ...prevState[el.id],
          name: trimmedName,
        },
      }
    })
    setIsEditingName(false)
  }

  const handleNameKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      commitNameChange()
    }
    if (e.key === 'Escape') {
      e.preventDefault()
      setTempName(name || '')
      setIsEditingName(false)
      setNameError('')
    }
  }

  const renderName = ({ el: itemEl, isSubItem: subItem, size, weight }) => {
    const displayName = isEditingName ? tempName : itemEl.name
    return (
      <div
        className={`flex flex-sm ${subItem ? 'sub-item-name-container' : ''}`}
      >
        <div
          className={`dot ${subItem ? 'dot-sm' : ''}`}
          style={{
            backgroundColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {holdLetter && !subItem && (
            <span
              style={{
                color: 'white',
                fontSize: '10px',
                fontWeight: 'bold',
                lineHeight: 1,
                userSelect: 'none',
              }}
            >
              {holdLetter}
            </span>
          )}
        </div>
        <span
          className={`item-name ${size ? `item-name-${size}` : ''} ${
            weight ? `item-name-${weight}` : ''
          }`}
          onClick={() => {
            if (!canEditName) return
            setIsEditingName(true)
            setTempName(itemEl.name || '')
            setNameError('')
          }}
          onMouseEnter={() => setNameHover(true)}
          onMouseLeave={() => setNameHover(false)}
          style={{
            cursor: canEditName ? 'text' : 'default',
            ...(canEditName && nameHover && !isEditingName
              ? { color: '#3E8BF7', textDecoration: 'underline' }
              : {}),
          }}
        >
          {isEditingName ? (
            <input
              type="text"
              className="form-control form-control-sm"
              value={tempName}
              autoFocus
              onChange={(e) => {
                setTempName(e.target.value)
                if (nameError) {
                  setNameError(validateName(e.target.value))
                }
              }}
              onBlur={commitNameChange}
              onKeyDown={handleNameKeyDown}
            />
          ) : (
            displayName
          )}
        </span>
        {nameError && (
          <span className="text-danger small ms-2">{nameError}</span>
        )}
      </div>
    )
  }

  return (
    <DroppableItem
      index={index}
      data={data}
      styles={`${styles || ''} ${isSubItem ? 'sub-item' : ''}`}
      hasHover={canAdd || canRemove}
      isDroppableInSelected={isDroppableInSelected}
    >
      <Item
        index={index}
        entity={entity}
        data={data}
        el={el}
        isSubItem={isSubItem}
        canRemove={canRemove}
        canAdd={canAdd}
        handleRemove={handleRemove}
        handleAdd={handleAdd}
        getObjectTotalSeatCount={getObjectTotalSeatCount}
        renderName={canEditName || holdLetter ? renderName : undefined}
      />
    </DroppableItem>
  )
}
